import { useCartState } from '../cart-provider';

export const useCartLiveValidationActions = () => {
  const [cartState] = useCartState();

  return {
    validateCartNow: cartState.validateCartNow,
    requestCartValidation: cartState.requestCartValidation,
  } as const;
};
